<template>
  <v-card class="mx-auto item" @click="clicked">
    <v-img min-height="220px" contain :src="src"> </v-img>
    <v-overlay :absolute="true" :value="!forSale" z-index="1">
      <div>完売しました</div>
    </v-overlay>
    <v-card-title class="subtitle-1">{{ text }}</v-card-title>
    <v-card-subtitle class="pb-2">yatsu-no-yoin</v-card-subtitle>
  </v-card>
</template>

<script>
export default {
  name: 'MerchCard',
  props: {
    src: String,
    text: String,
    forSale: Boolean,
  },
  methods: {
    clicked() {
      this.$emit('card-click');
    },
  },
};
</script>

<style scoped>
.item {
  cursor: pointer;
}
</style>
